  <div class="chartWrapper" [ngClass]="{'hideChart' : !showChart}">
    <ion-spinner *ngIf="isLoading" class="loading"></ion-spinner>
    <canvas #chartCanvas style="position: relative;"></canvas>
  </div>
